import { VFC } from 'react';
import { Icon, IconProps } from '@chakra-ui/react';
import dynamic from 'next/dynamic';

export const DynamicIcon: VFC<{ icon: string } & Omit<IconProps, 'as'>> = ({ icon, ...props }) => {
  if (!icon) return null;
  const as = dynamic(() => import(`./assets/${icon}`).then((module) => module[icon]));
  return <Icon as={as} {...props} />;
};
